var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroFlashVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 435,
    viewBox: "0 0 614 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.594 202.603L536.412 333.065L8.02864 430.97L218.404 236.065L220.384 234.231L218.404 232.397L77.5882 101.937L605.971 4.03025L395.594 198.935L393.614 200.769L395.594 202.603Z",
    stroke: "#FFA41B",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFlashVector);
export default __webpack_public_path__ + "static/media/hero-flash-vector.b866115daa755fa8a6f0040f76ea3e1f.svg";
export { ForwardRef as ReactComponent };